import {
  CLEAR,
  UPDATE_SELECT_SITE,
  UPDATE_SEARCH_VALUE,
  CLEAR_NVBUGS_LIST,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SELECT_SITE,
  UPDATE_PAGE_SIZE,
  CHANGE_EDIT,
  UPDATE_EDIT,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_NVBUGS_LIST,
  FETCH_NVBUGS,
  FETCH_NVBUGS_START,
  FETCH_NVBUGS_SUCCESS,
  FETCH_NVBUGS_ERROR,
  PATCH_NVBUGS,
  PATCH_NVBUGS_START,
  PATCH_NVBUGS_SUCCESS,
  PATCH_NVBUGS_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clear = () => ({ type: CLEAR })
const clearNvbugsList = () => ({ type: CLEAR_NVBUGS_LIST })
const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const changeSelectSite = (id, synopsis) => ({ type: CHANGE_SELECT_SITE, id, synopsis })
const updateSelectSite = (id) => ({ type: UPDATE_SELECT_SITE, id })
const updateSearchValue = (value) => ({ type: UPDATE_SEARCH_VALUE, value })
const updateNvbugsList = (sites) => ({ type: UPDATE_NVBUGS_LIST, sites })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const changeEdit = (enable) => ({ type: CHANGE_EDIT, enable })
const updateEdit = (enable) => ({ type: UPDATE_EDIT, enable })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

/* Async Calls */
const fetchNvbugs = () => ({ type: FETCH_NVBUGS })
const fetchNvbugsStart = () => ({ type: FETCH_NVBUGS_START })
const fetchNvbugsSuccess = () => ({ type: FETCH_NVBUGS_SUCCESS })
const fetchNvbugsError = (error) => ({ type: FETCH_NVBUGS_ERROR, error })
const startFetchNvbugsAsync = buildAsyncAction(
  FETCH_NVBUGS,
  FETCH_NVBUGS_START,
  [FETCH_NVBUGS_SUCCESS, FETCH_NVBUGS_ERROR]
)

const patchNvbugs = (value) => ({ type: PATCH_NVBUGS, value })
const patchNvbugsStart = () => ({ type: PATCH_NVBUGS_START })
const patchNvbugsSuccess = () => ({ type: PATCH_NVBUGS_SUCCESS })
const patchNvbugsError = (error) => ({ type: PATCH_NVBUGS_ERROR, error })
const startPatchNvbugsAsync = buildAsyncAction(
  PATCH_NVBUGS,
  PATCH_NVBUGS_START,
  [PATCH_NVBUGS_SUCCESS, PATCH_NVBUGS_ERROR]
)

export {
  clear,
  incrementPage,
  decrementPage,
  changePageSize,
  changeSearchValue,
  changeSelectSite,
  updateSelectSite,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateNvbugsList,
  updateSearchValue,
  changeEdit,
  updateEdit,
  clearNvbugsList,
  fetchNvbugs,
  fetchNvbugsStart,
  fetchNvbugsSuccess,
  fetchNvbugsError,
  startFetchNvbugsAsync,
  patchNvbugs,
  patchNvbugsStart,
  patchNvbugsSuccess,
  patchNvbugsError,
  startPatchNvbugsAsync,
}
